import BaseRepository from '@repositories/desktop/BaseRepository';
import AjaxService from '@services/AjaxService';

export default class FirmGroupRepository extends BaseRepository {
  protected baseUrl = '/de/Schaden-Manager/firmgroup';

  public constructor(ajaxService: AjaxService) {
    super(ajaxService);
  }

  public create(attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      '/api/desktop/firm-groups/create',
      {data: {attributes}}
    );
  }

  public delete(firmGroupId: number): Promise<any> {
    return this.ajaxService.sendDelete(
      `/api/desktop/firm-groups/${firmGroupId}/delete`
    );
  }

  public getBlank(): Promise<any> {
    return this.ajaxService.getJson('/api/desktop/firm-groups/blank');
  }

  public loadFirmGroup(firmGroupId: number): Promise<any> {
    return this.ajaxService.getJson(`/api/desktop/firm-groups/${firmGroupId}`);
  }

  public saveFirmGroupBasedata(firmGroupId: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `/api/desktop/firm-groups/${firmGroupId}/basedata/save`,
      {data: {attributes}}
    );
  }
}
